import { Component, h } from 'preact';

class TcrMarkdownView extends Component
{
    constructor(props)
    {
        super(props);
    }

    markdownToHTML(text)
    {
        if (!text || typeof text !== 'string') return '';
        // supported tags: #, ##, ### for headings, otherwise paragraphs
        // inline formats: **for bold** and *for italic*
        // - for lists
        // links: [text](url) 
        let lines = text.split('\n');
        let html = lines.map(line => {
            let type = 'p';
            if (line.startsWith('## ')) type = 'h3';
            else if (line.startsWith('# ')) type = 'h2';
            else if (line.startsWith('- ')) type = 'ul';
            line = line.replace(/^#+ /, '');
            line = line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
            line = line.replace(/\*(.+?)\*/g, '<em>$1</em>');
            line = line.replace(/\[(.+?)\]\((https?:\/\/.+?)\)/g, '<a href="$2" target="_blank">$1</a>');
            line = line.replace(/^- (.+)/, '<li>$1</li>');
            return `<${type}>${line}</${type}>`;
        }).join('').replace(/<\/ul><ul>/g, '');
        return html;
    }

    render()
    {
        return (
            <div class={this.props.class} dangerouslySetInnerHTML={{ __html: this.markdownToHTML(this.props.content) }}></div>
        );
    }
}

export { TcrMarkdownView };